// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const GlobeIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm8.94 10h-4a16.29 16.29 0 00-2.68-7.7 9 9 0 016.68 7.7zM9.06 13h5.88A14.29 14.29 0 0112 20.45 14.28 14.28 0 019.06 13zm0-2A14.29 14.29 0 0112 3.55 14.28 14.28 0 0114.94 11zm.68-7.7A16.31 16.31 0 007.07 11h-4a9 9 0 016.67-7.7zM3.06 13h4a16.29 16.29 0 002.68 7.7A9 9 0 013.06 13zm11.2 7.7a16.35 16.35 0 002.67-7.7h4a9 9 0 01-6.67 7.7z"/></svg>'} />;

GlobeIcon.displayName = 'GlobeIcon';

export default GlobeIcon;
